<template>
    <div>
        员工调薪
    </div>
</template>

<script>
    export default {
        name: "PerSalary"
    }
</script>

<style scoped>

</style>
